module.exports = __webpack_public_path__ + "static/bunting-609e0d9bd6107502a96bc9b2999ed0b9.jpg";